export default __webpack_public_path__ + "static/media/Inter-MediumItalic.d29ef50a.woff2";